import React, { useEffect, useState } from 'react'
import CustomPagination from "../../../common/Pagination";
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getWebhookReceiverLogAuditDatatableAsync,resetSelectedRecordObjectInState,setPageSize,setSortConfig } from './WebHookReceiverLogsAuditSlice';
import { useNavigate } from 'react-router-dom';
import '../../../common/css/timeLive.css'

const WebHookReceiverLogsAuditItem = (props: any) => {
    const {WebHookReceiverLogsAuditList,webhookreceiverlogid,t} = props;
    const {  isReload,currentPage ,pageSize,totalItems,start,search,sortDirection,sortIndex ,recordsFiltered,isSearch,isSort,isLoading} = useAppSelector((state) => state.webHookReceiverLogAudit);
    const dispatch = useAppDispatch();
    
    useEffect(() => {
        if (isSort) {
            dispatch(getWebhookReceiverLogAuditDatatableAsync({ currentPage: currentPage, pageSize: pageSize, start: start, order: sortIndex, orderDir: sortDirection, search: search }));
        }
    }, [isSort]);

    const handleSort = (Index: number) => {        
        const Dir = Index === sortIndex && sortDirection === 'asc' ? 'desc' : 'asc';
        dispatch(setSortConfig({ Index, Dir }));
        
    };


    return (
        <>
        {isLoading && (
            <div className="spinner-overlay">
                <div className="spinner"></div>
            </div>
        )}
        <table className="table table-row-bordered  align-middle gs-1 gy-2 gx-1" >
            <thead>
                <tr className="thHeading align-middle "  >
                    <th className='min-w-100%' onClick={() => handleSort(0)} >
                        {t('Date')}
                        {sortIndex === 0 && (
                            <span>{sortDirection === 'asc' ? ' ↑' : ' ↓'}</span>
                        )}
                    </th>
                    <th className='min-w-100%' onClick={() => handleSort(1)}>
                        {t('Status')}
                        {sortIndex === 1 && (
                            <span>{sortDirection === 'asc' ? ' ↑' : ' ↓'}</span>
                        )}
                    </th>
                    <th className='min-w-100%' onClick={() => handleSort(2)}>
                        {t('Action')}
                        {sortIndex === 2 && (
                            <span>{sortDirection === 'asc' ? ' ↑' : ' ↓'}</span>
                        )}
                    </th>
                    <th className='min-w-100%' onClick={() => handleSort(3)}>
                        {t('State')}
                        {sortIndex === 3 && (
                            <span>{sortDirection === 'asc' ? ' ↑' : ' ↓'}</span>
                        )}
                    </th>
                    <th className='min-w-100%' onClick={() => handleSort(4)}>
                        {t('Coming From')}
                        {sortIndex === 4 && (
                            <span>{sortDirection === 'asc' ? ' ↑' : ' ↓'}</span>
                        )}
                    </th>
                    <th className='min-w-100%' onClick={() => handleSort(5)}>
                        {t('Action Description')}
                        {sortIndex === 5 && (
                            <span>{sortDirection === 'asc' ? ' ↑' : ' ↓'}</span>
                        )}
                    </th>
                    
                </tr>
            </thead>
            <tbody>
                {WebHookReceiverLogsAuditList.length === 0 && <tr><td colSpan={6}><p className='noDataFound'>{t('No Record Found')}</p></td></tr>}
                {WebHookReceiverLogsAuditList.length > 0 && WebHookReceiverLogsAuditList.map((WebHookReceiverLogsAuditDetail: any, i: any) => (
                    <tr key={i}>
                        <td>
                        <span className="d-block"> 
                                {WebHookReceiverLogsAuditDetail.AuditDateTime}
                            </span>
                        </td>
                        <td>
                            {(WebHookReceiverLogsAuditDetail.ActionStatus === 'Fail' || WebHookReceiverLogsAuditDetail.ActionStatus === 'fail')
                                ? <span className="badge badge-light-danger fs-7">{WebHookReceiverLogsAuditDetail.ActionStatus}</span>
                                : (WebHookReceiverLogsAuditDetail.ActionStatus === 'in progress' || WebHookReceiverLogsAuditDetail.ActionStatus === 'In Progress') ?  <span className="badge badge-light-primary fs-7">{WebHookReceiverLogsAuditDetail.ActionStatus}</span>
                                    :<span className="badge badge-light-success fs-7">{WebHookReceiverLogsAuditDetail.ActionStatus}</span>
                            }
                        </td>
                        <td>
                            <span className="d-block"> 
                                {WebHookReceiverLogsAuditDetail.AuditDMLAction}
                            </span>
                        </td>
                        <td>
                            <span className="d-block"> 
                                {WebHookReceiverLogsAuditDetail.AuditDataState}
                            </span>
                        </td>
                        <td>
                            <span className="d-block"> 
                                {WebHookReceiverLogsAuditDetail.RequestComingFrom}
                            </span>
                        </td>
                        <td>
                            <span className="d-block"> 
                                {WebHookReceiverLogsAuditDetail.ActionDescription}
                            </span>
                        </td>
                       
                    </tr>
                ))}

            </tbody>
        </table >
    </>
      
    )
}

export default WebHookReceiverLogsAuditItem

